import { Skeleton } from '@mui/material';

export type PanelSkeletonProps = {
  /** Height of the chart area placeholder. Matches the panel it stands in for. */
  height?: number;
  /** Render the title placeholder line. */
  withTitle?: boolean;
};

/** Loading placeholder shaped like a chart panel, so the layout does not jump when data lands. */
export const PanelSkeleton = ({ height = 240, withTitle = true }: PanelSkeletonProps): JSX.Element => (
  <div data-testid="dod-panel-skeleton">
    {withTitle && <Skeleton variant="text" width="40%" height={24} />}
    <Skeleton variant="rectangular" height={height} />
  </div>
);
